import { Check, ChevronRight, CircleAlert, Terminal } from "lucide-react";
import type { ScriptExecution } from "../types";
import type { Language } from "../lib/languages";
import { ui } from "../lib/localization";

export function ScriptExecutionPanel({ executions, language, settled }: { executions?: ScriptExecution[]; language: Language; settled: boolean }) {
  if (!executions?.length) return null;
  return <div className="script-executions">
    {executions.map((execution) => {
      const status = execution.status === "running" && settled ? "error" : execution.status;
      const label = ui(language, status === "running" ? "Running script" : status === "complete" ? "Script completed" : "Script interrupted or failed");
      return <details className={`script-run ${status}`} key={execution.id} open={status === "complete" && Boolean(execution.stdout)}>
        <summary>
          {status === "complete" ? <Check size={16} /> : status === "error" ? <CircleAlert size={16} /> : <Terminal size={16} />}
          <span className="script-run-label"><strong role="status">{label}</strong><span dir="auto">{execution.title}</span></span>
          <small>{execution.language === "python" ? "Python" : "JavaScript"}{execution.elapsedMs !== undefined ? ` · ${(execution.elapsedMs / 1000).toFixed(1)}s` : ""}</small>
          <ChevronRight className="script-disclosure" size={14} aria-hidden="true" />
        </summary>
        <div className="script-run-detail">
          {execution.stdout ? <><p>{ui(language, "Script output")}</p><pre dir="auto">{execution.stdout}</pre></> : null}
          {execution.stderr ? <><p>{ui(language, "Script diagnostics")}</p><pre dir="auto">{execution.stderr}</pre></> : null}
          {execution.truncated ? <p>{ui(language, "Only an output preview is shown. Check the exported file; partial files are marked in their name.")}</p> : null}
          <details className="script-source"><summary>{ui(language, "Executed code")}</summary><pre dir="ltr"><code>{execution.code}</code></pre></details>
        </div>
      </details>;
    })}
  </div>;
}
